import React, { useState, useEffect } from 'react';
import { StyleSheet } from 'react-native';


interface ConfirmOrderActionProps {
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    content: string;
    mainTable: string;
    newTable: string;
}


const ConfirmOrderAction: React.FC<ConfirmOrderActionProps> = ({ onClose, onConfirm, title, content, mainTable, newTable }) => {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);


    useEffect(() => {
        const handleResize = () => {
            console.log("onresize: innerWidth: " + window.innerWidth + "innerHeight: " + innerHeight)
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.onresize = handleResize;

        return () => {
            window.onresize = null;
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        const updateSize = () => {
            console.log("update size")
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", updateSize);
        window.addEventListener("focus", updateSize);
        document.addEventListener("visibilitychange", updateSize);

        return () => {
            window.removeEventListener("resize", updateSize);
            window.removeEventListener("focus", updateSize);
            document.removeEventListener("visibilitychange", updateSize);
        };
    }, []);

    const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 500 ? 430 : windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'absolute',
            zIndex: 9999,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: 16
        },
    });

    return (
        <div style={styles.popup} className='ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-end'>
                <button className='text-btn p-0 m-0 d-flex justify-content-center' onClick={onClose}>
                    <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L1 13M1 1L13 13" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>

            <div className='px-4 pb-3 d-flex flex-column'>
                <h5>{title}</h5>
                <p>{content}</p>
                <div className='d-flex align-items-center gap-4'>
                    <label>Current table: {mainTable}</label>
                    <svg width="8" height="12" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 13.5L7 7.5L1 1.5" stroke="#666666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <label>New table: {newTable}</label>
                </div>
            </div>
            <div className='py-2 px-3 d-flex mt-3 gap-2 justify-content-end align-items-center gap-2' style={{flexWrap: 'nowrap'}}>
                <button className='white-filled-btn w-100' onClick={onClose} style={{borderRadius: 8}}>Cancel</button>
                <button className='blue-filled-btn w-100' onClick={onConfirm} style={{border: 'none', height: 34.5, borderRadius: 8}}>Confirm</button>
            </div>
        </div>
    );
};

export default ConfirmOrderAction;

